// Locale-aware formatting — always use these instead of hand-rolled
// toLocaleDateString('en-US', …) or "$" + toFixed(). Driven by the active UI
// language; falls back to en-US if Intl rejects a tag.
import i18n from './index';

function activeLocale() {
  return i18n.language || 'en';
}

export function formatDate(value, options = { year: 'numeric', month: 'short', day: 'numeric' }) {
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(activeLocale(), options).format(date);
  } catch {
    return new Intl.DateTimeFormat('en-US', options).format(date);
  }
}

export function formatDateTime(value) {
  return formatDate(value, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatNumber(value, options = {}) {
  const n = Number(value);
  if (!isFinite(n)) return '';
  try {
    return new Intl.NumberFormat(activeLocale(), options).format(n);
  } catch {
    return new Intl.NumberFormat('en-US', options).format(n);
  }
}

// Prices are always charged in USD — only the presentation localizes
// (symbol placement, decimal separator: $12.34 vs 12,34 $US).
export function formatCurrencyUSD(amountDollars, options = {}) {
  return formatNumber(amountDollars, { style: 'currency', currency: 'USD', ...options });
}

export function formatCentsUSD(cents, options = {}) {
  return formatCurrencyUSD((Number(cents) || 0) / 100, options);
}
